import React, { useMemo } from "react";
import PropTypes from "prop-types";
const VmoAccountUserImage = ({ src, name, style, type, ...rest }) => {
  const img = useMemo(() => src, [src]);
  const userName = useMemo(() => name, [name]);
  const getStyle = useMemo(() => {
    const obj = {
      round: { borderRadius: "50%" },
      square: { borderRadius: "8px" },
    };
    return obj[type];
  }, [type]);

  const getDummyAvatar = () => {
    if (img) {
      return <img width={36} height={36} src={img} alt="Avatar " />;
    }
    if (userName) {
      const words = userName?.split(" ");
      if (words.length > 1) {
        const firstLetters = [words[0][0], words[1][0]];
        return firstLetters;
      }
      const firstLetters = [words[0][0]];
      return firstLetters;
    }
    if (!img && !userName) {
      return "N/A";
    }
  };
  return (
    <React.Fragment>
      <div className="dummyAvatar" style={{ ...getStyle, ...style }} {...rest}>
        {getDummyAvatar()}
      </div>
    </React.Fragment>
  );
};

export default VmoAccountUserImage;

VmoAccountUserImage.propTypes = {
  src: PropTypes.string,
  name: PropTypes.string,
  style: PropTypes.object,
  type: PropTypes.oneOf(["round", "square"]),
};
